import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { uuidValidate } from "uuid-validate";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./css/landing.css"
class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateData: "",
      projectData: "",
      formVisible: true,
      thankYouMessage: '',
      isOpen: false,
      lightboxOpen: false,
      photoIndex: 0,
      images: []
    };

    this.formRef = React.createRef();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleGalleryClick = this.handleGalleryClick.bind(this);
  }

  unlockPageScroll = () => {
    document.documentElement.style.overflowY = "auto";
    document.documentElement.style.height = "auto";
    document.body.style.overflowY = "auto";
    document.body.style.height = "auto";
    document.body.classList.remove("ReactModal__Body--open");

    const wrappers = document.querySelectorAll("#u_body, .u-body");
    wrappers.forEach((el) => {
      el.style.overflow = "visible";
      el.style.height = "auto";
      el.style.maxHeight = "none";
    });
  };

  componentDidMount() {
    const { match: { params } } = this.props;
    const projectId = params.projectId;

    this.unlockPageScroll();
    trackSource();
    axios
      .get(`https://rscoreapi.azurewebsites.net/api/ProjectLandingPage/byprojectguid?guid=${projectId}`)
      .then((res) => {
        this.setState({ templateData: res.data }, () => {
          this.unlockPageScroll();
          clearTimeout(this._formBindTimer);
          clearTimeout(this._galleryTimer);
          this._formBindTimer = setTimeout(() => this.bindLandingForm(), 50);
          this._galleryTimer = setTimeout(() => this.addImageClickListeners(), 50);
        });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });

    axios
      .get("https://rscoreapi.azurewebsites.net/api/ProjectExt/guid", {
        params: { projectid: projectId },
      })
      .then((res) => {
        this.setState({ projectData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching project data!", error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.templateData !== prevState.templateData ||
      this.state.formVisible !== prevState.formVisible
    ) {
      this.unlockPageScroll();
      clearTimeout(this._galleryTimer);
      clearTimeout(this._formBindTimer);
      this._galleryTimer = setTimeout(() => this.addImageClickListeners(), 50);
      this._formBindTimer = setTimeout(() => this.bindLandingForm(), 50);
    }

    if (prevState.lightboxOpen && !this.state.lightboxOpen) {
      this.unlockPageScroll();
    }
  }

  componentWillUnmount() {
    clearTimeout(this._galleryTimer);
    clearTimeout(this._formBindTimer);
    this.unbindLandingForm();
    const root = this.formRef.current;
    if (root) {
      root.removeEventListener("click", this.handleGalleryClick);
    }
    document.documentElement.style.overflowY = "";
    document.documentElement.style.height = "";
    document.body.style.overflowY = "";
    document.body.style.height = "";
    document.body.classList.remove("ReactModal__Body--open");
  }

  isSubmitControl = (el) => {
    if (!el || !el.closest) return null;
    const control = el.closest(
      "button, input[type='submit'], input[type='button'], a.u-btn, a[role='button'], [role='button']"
    );
    if (!control || !this.formRef.current?.contains(control)) return null;

    const type = (control.getAttribute("type") || "").toLowerCase();
    if (type === "reset") return null;
    if (type === "submit") return control;

    const text = `${control.textContent || ""} ${control.value || ""} ${control.className || ""} ${control.getAttribute("aria-label") || ""}`.toLowerCase();
    const looksLikeSubmit =
      /submit|send|register|sign\s*up|get\s*started|contact|enquire|inquire|join|book|request|download|apply|u-btn/.test(
        text
      );

    // Native button default type is submit
    if (control.tagName === "BUTTON" && type !== "button") return control;
    if (looksLikeSubmit) return control;
    return null;
  };

  handleDelegatedSubmitClick = (event) => {
    const control = this.isSubmitControl(event.target);
    if (!control) return;

    event.preventDefault();
    event.stopPropagation();
    this.handleFormSubmit(event);
  };

  bindLandingForm = () => {
    const root = this.formRef.current;
    if (!root || !this.state.formVisible) return;

    this.unbindLandingForm();

    const formEl = root.querySelector("form");
    if (formEl) {
      formEl.setAttribute("novalidate", "novalidate");
      formEl.addEventListener("submit", this.handleFormSubmit);
    }

    root.addEventListener("input", this.handleFormInput);
    root.addEventListener("change", this.handleFormInput);
    // Capture submit-like clicks (Unlayer often uses button/link, not a real submit)
    root.addEventListener("click", this.handleDelegatedSubmitClick, true);
    this._formBound = true;
  };

  unbindLandingForm = () => {
    const root = this.formRef.current;
    if (!root) return;

    const formEl = root.querySelector("form");
    if (formEl) {
      formEl.removeEventListener("submit", this.handleFormSubmit);
    }
    root.removeEventListener("input", this.handleFormInput);
    root.removeEventListener("change", this.handleFormInput);
    root.removeEventListener("click", this.handleDelegatedSubmitClick, true);
    this._formBound = false;
  };

  getGalleryImages = () => {
    const root = this.formRef.current;
    if (!root) return [];

    const preferred = root.querySelectorAll(
      ".galleryImg img, [class*='galleryImg'] img, [class*='gallery'] img, #u_content_html_4 img, [id*='gallery'] img"
    );
    if (preferred.length) return Array.from(preferred);

    return Array.from(root.querySelectorAll("img")).filter((img) => {
      const src = (img.getAttribute("src") || img.src || "").toLowerCase();
      if (!src || src.includes("logo") || src.includes("icon") || src.includes("favicon")) {
        return false;
      }
      const w = parseInt(img.getAttribute("width"), 10) || img.naturalWidth || img.width || 0;
      const h = parseInt(img.getAttribute("height"), 10) || img.naturalHeight || img.height || 0;
      if ((w && w < 80) || (h && h < 80)) return false;
      return true;
    });
  };

  handleGalleryClick = (event) => {
    const img = event.target.closest("img");
    if (!img || !this.formRef.current?.contains(img)) return;

    const galleryImages = this.getGalleryImages();
    const photoIndex = galleryImages.indexOf(img);
    if (photoIndex < 0) return;

    event.preventDefault();
    event.stopPropagation();
    this.setState({
      lightboxOpen: true,
      photoIndex,
      images: galleryImages.map((item) => item.currentSrc || item.src),
    });
  };

  addImageClickListeners = () => {
    const root = this.formRef.current;
    if (!root) return;

    const galleryImages = this.getGalleryImages();
    galleryImages.forEach((img) => {
      img.style.cursor = "pointer";
      img.setAttribute("data-lightbox", "gallery");
    });

    root.removeEventListener("click", this.handleGalleryClick);
    root.addEventListener("click", this.handleGalleryClick);

    if (galleryImages.length) {
      this.setState({
        images: galleryImages.map((img) => img.currentSrc || img.src),
      });
    }
  };

  handleFormInput = (event) => {
    const field = event.target;
    if (!field || !field.name) return;
    field.classList.remove("lp-invalid");
    const errorEl = field.parentElement?.querySelector(".lp-field-error");
    if (errorEl) errorEl.remove();
  };

  clearFormFieldErrors = (formEl) => {
    if (!formEl) return;
    formEl.querySelectorAll(".lp-field-error").forEach((el) => el.remove());
    formEl.querySelectorAll(".lp-invalid").forEach((el) => {
      el.classList.remove("lp-invalid");
    });
  };

  showFormFieldError = (field, message) => {
    if (!field) return;
    field.classList.add("lp-invalid");
    const existing = field.parentElement?.querySelector(".lp-field-error");
    if (existing) {
      existing.textContent = message;
      return;
    }
    const errorEl = document.createElement("div");
    errorEl.className = "lp-field-error";
    errorEl.textContent = message;
    field.insertAdjacentElement("afterend", errorEl);
  };

  getFormScope = () => {
    const root = this.formRef.current;
    if (!root) return null;
    return root.querySelector("form") || root;
  };

  getFormField = (scope, names, hints = []) => {
    if (!scope) return null;
    for (const name of names) {
      const field = scope.querySelector(`[name="${name}"]`);
      if (field) return field;
    }
    const nodes = Array.from(scope.querySelectorAll("input, textarea, select"));
    for (const name of names) {
      const lower = String(name).toLowerCase();
      const field = nodes.find((node) => {
        const id = (node.id || "").toLowerCase();
        const nm = (node.name || "").toLowerCase();
        return id === lower || nm === lower || id.includes(lower) || nm.includes(lower);
      });
      if (field) return field;
    }
    for (const hint of hints) {
      const field = nodes.find((node) => {
        const hay = `${node.name || ""} ${node.id || ""} ${node.placeholder || ""} ${node.getAttribute("aria-label") || ""}`.toLowerCase();
        return hint.test(hay);
      });
      if (field) return field;
    }
    return null;
  };

  getFieldValue = (field) => {
    if (!field) return "";
    if (field.type === "checkbox") return field.checked ? String(field.value || "true") : "";
    if (field.type === "radio") {
      const checked = field.form
        ? field.form.querySelector(`input[type="radio"][name="${field.name}"]:checked`)
        : this.getFormScope()?.querySelector(`input[type="radio"][name="${field.name}"]:checked`);
      return checked ? String(checked.value || "").trim() : "";
    }
    return String(field.value == null ? "" : field.value).trim();
  };

  collectFormValues = (scope) => {
    const firstNameField = this.getFormField(
      scope,
      ["first_name", "firstName", "firstname", "fname"],
      [/first\s*name/, /^first$/, /fname/]
    );
    const lastNameField = this.getFormField(
      scope,
      ["last_name", "lastName", "lastname", "lname"],
      [/last\s*name/, /^last$/, /lname/]
    );
    const emailField = this.getFormField(
      scope,
      ["email", "email_address", "emailAddress"],
      [/e-?mail/]
    ) || scope.querySelector("input[type='email']");
    const phoneField = this.getFormField(
      scope,
      ["phone_number", "phone", "mobile", "mobileNo", "cellPhone", "tel"],
      [/phone/, /mobile/, /cell/]
    ) || scope.querySelector("input[type='tel']");
    const agentField = this.getFormField(
      scope,
      ["isrealtor", "withAgent", "with_agent", "realtor"],
      [/realtor/, /agent/]
    );

    const withAgentRaw = this.getFieldValue(agentField).toLowerCase();
    const withAgent =
      withAgentRaw === "true" || withAgentRaw === "yes" || withAgentRaw === "1"
        ? "true"
        : "false";

    return {
      firstNameField,
      lastNameField,
      emailField,
      phoneField,
      agentField,
      values: {
        firstName: this.getFieldValue(firstNameField),
        lastName: this.getFieldValue(lastNameField),
        email: this.getFieldValue(emailField),
        mobile: this.getFieldValue(phoneField),
        withAgent,
      },
    };
  };

  validateLandingForm = (scope) => {
    this.clearFormFieldErrors(scope);
    const collected = this.collectFormValues(scope);

    const rules = [
      {
        field: collected.firstNameField,
        label: "First name",
        value: collected.values.firstName,
        validate: (value) => (value ? "" : "First name is required"),
      },
      {
        field: collected.lastNameField,
        label: "Last name",
        value: collected.values.lastName,
        validate: (value) => (value ? "" : "Last name is required"),
      },
      {
        field: collected.emailField,
        label: "Email",
        value: collected.values.email,
        // If email field exists on the template, always require it
        validate: (value) => {
          if (!value) return "Email is required";
          const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          return emailOk ? "" : "Enter a valid email";
        },
      },
      {
        field: collected.phoneField,
        label: "Phone",
        value: collected.values.mobile,
        validate: (value) => {
          if (!value) return "Phone is required";
          const digits = value.replace(/\D/g, "");
          return digits.length >= 10 ? "" : "Enter a valid phone number";
        },
      },
    ];

    const errors = [];
    let foundFields = 0;

    rules.forEach((rule) => {
      if (!rule.field) return;
      foundFields += 1;
      const message = rule.validate(rule.value);
      if (message) {
        this.showFormFieldError(rule.field, message);
        errors.push(message);
      }
    });

    if (foundFields === 0) {
      errors.push("Form fields not found");
    }

    return { isValid: errors.length === 0, errors, values: collected.values };
  };

  handleFormSubmit(event) {
    if (event?.preventDefault) event.preventDefault();
    if (event?.stopPropagation) event.stopPropagation();

    // Prevent click + submit double-fire
    const now = Date.now();
    if (this._lastSubmitAt && now - this._lastSubmitAt < 800) return;
    this._lastSubmitAt = now;

    if (this._isSubmitting) return;

    const scope = this.getFormScope();
    if (!scope) {
      toast.error("Form not found");
      return;
    }

    const { isValid, errors, values } = this.validateLandingForm(scope);

    if (!isValid) {
      errors.forEach((error) => toast.error(error));
      const firstInvalid = scope.querySelector(".lp-invalid");
      if (firstInvalid?.scrollIntoView) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        firstInvalid.focus?.();
      }
      return;
    }

    const datt = {
      projectCampaignId: 3100,
      agentId: this.state.templateData.agentId,
      projectCampaignGuid: this.props.match.params.projectId,
      campaignProjectId: this.state.templateData.landingPageProjectId,
      campaignProjectGuid: this.props.match.params.projectId,
      leadSourceId: 3,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      mobile: values.mobile,
      withAgent: values.withAgent,
      leadSourceText: "",
    };

    this._isSubmitting = true;
    toast.loading("Please wait...");
    axios
      .post("https://rscoreapi.azurewebsites.net/api/ProjectCampaignLead", datt, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.dismiss();

        if (response.data.success) {
          this.setState({
            formVisible: false,
            thankYouMessage: `We will contact you shortly to go over the next steps. If you have questions feel free to call.`,
          });
        } else {
          (response.data.validationErrors || []).forEach((error) => {
            toast.error(error);
          });
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("Error submitting the form");
        console.error("There was an error submitting the form!", error);
      })
      .finally(() => {
        this._isSubmitting = false;
      });
  }

  render() {
    const { templateData, projectData, lightboxOpen, photoIndex, images, formVisible, thankYouMessage } = this.state;
       const templateId = templateData?.landingPageTemplateId;
   
    return (
      <React.Fragment>
        <MetaTags>
          <title>{projectData?.projectName || templateData?.landingPageTitle || "Landing Page | Realty Space"}</title>
          {projectData?.projectLogoLink && (
            <link rel="icon" href={projectData.projectLogoLink} />
          )}
        </MetaTags>
        <ToastContainer autoClose={2000} />
        
        {formVisible ? (
          <div
            ref={this.formRef}
            dangerouslySetInnerHTML={{
              __html: templateData.landingPageFullContent || "Loading content..."
            }}
          />
        ) : (
          <div className="text-center">
            <h4 className="text-danger">Thank you </h4>
            {/* <h5>Thank you for submitting the form.</h5> */}
            <h5>{thankYouMessage}</h5>
          </div>
        )}

        {lightboxOpen && images.length > 0 && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ lightboxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </React.Fragment>
    );
  }
}

function trackSource() {
  const sourceInfo = {
    source: detectSource(),
    timestamp: new Date().toISOString(),
    browser: navigator.userAgent,
    platform: getPlatform()
  };
  
 
}

function detectSource() {
  const referrer = document.referrer;
  if (referrer.includes("google.com")) return "google";
  if (referrer.includes("facebook.com")) return "facebook";
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("source") || "direct";
}

function getPlatform() {
  const platform = navigator.platform || "unknown";
  return platform.toLowerCase();
}
LandingPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history:PropTypes.object
};
export default connect()(withTranslation()(LandingPage));

